import { GLOBAL_MODALS, globalModals } from '@/state/globalSettings';
import { isLoggedIn } from '@/state/userInfo';
import { useAtomValue, useSetAtom } from 'jotai';

const useLoginModal = () => {
  const setModals = useSetAtom(globalModals);
  const isLogin = useAtomValue(isLoggedIn);

  return [
    isLogin,
    () =>
      setModals({
        [GLOBAL_MODALS.LOGIN]: true,
      }),
  ] as const;
};

export default useLoginModal;
